// src/HeroPage/ServicePerks.tsx
import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { AboutUs } from "./AboutUs";
import HomeFaqSection from "../components/HomeFaqSection";

/** ───────── Old strip layout (small, airy), but with NEW icons & texts ───────── */

const STROKE = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

/* Icons kept thin to match the old design */
const IconAppointment = () => (
  <svg width="100%" viewBox="0 0 48 48" aria-hidden>
    <rect x="10" y="10" width="28" height="26" {...STROKE} />
    <path d="M8 10h32" {...STROKE} />
    <path d="M16 10v26M32 10v26" {...STROKE} />
    <rect x="21" y="22" width="6" height="14" {...STROKE} />
    <circle cx="24" cy="29" r="1.8" {...STROKE} />
    <path d="M8 36h32" {...STROKE} />
  </svg>
);

const IconShippingReturns = () => (
  <svg width="100%" viewBox="0 0 48 48" aria-hidden>
    <path d="M29 12c-3 2-6 3-10 4" {...STROKE} />
    <path d="M28 12c2 0 3 1 4 2" {...STROKE} />
    <path d="M14 26c6-2 12-3 18-2 2 .3 3 1.3 4 2.5" {...STROKE} />
    <rect x="20" y="20" width="10" height="10" rx="1.8" {...STROKE} />
    <path d="M22 20c0-2 1.5-3.5 3-3.5s3 1.5 3 3.5" {...STROKE} />
    <path d="M11 31a7 7 0 0 0 7 7h7" {...STROKE} />
    <path d="M22 40l3-2-3-2" {...STROKE} />
  </svg>
);

const IconAtYourService = () => (
  <svg width="100%" viewBox="0 0 48 48" aria-hidden>
    <path d="M8 30c4-1 8-1 12 0l10 3c2 .6 4-.4 5-2" {...STROKE} />
    <path d="M12 34c5 2 10 3 15 3h3c2 0 4-1 5-3" {...STROKE} />
    <rect x="26" y="16" width="12" height="8" rx="1.8" {...STROKE} />
    <rect x="27" y="12" width="10" height="4" rx="1.2" {...STROKE} />
    <circle cx="32" cy="14" r="0.8" {...STROKE} />
  </svg>
);

const IconBlueBox = () => (
  <svg width="100%" viewBox="0 0 48 48" aria-hidden>
    <rect x="14" y="6" width="20" height="12" rx="2.2" {...STROKE} />
    <rect x="12" y="20" width="24" height="16" rx="2.6" {...STROKE} />
    <path d="M24 26a5 5 0 0 0-5 5" {...STROKE} />
    <path d="M24 22l3 3-3 3-3-3 3-3z" {...STROKE} />
    <circle cx="24" cy="31" r="0.8" {...STROKE} />
  </svg>
);

type Item = { icon: React.ReactNode; label: string };

const ITEMS: Item[] = [
  { icon: <IconAppointment />, label: "Book An\nAppointment" },
  { icon: <IconShippingReturns />, label: "Shipping &\nReturns" },
  { icon: <IconAtYourService />, label: "At Your\nService" },
  { icon: <IconBlueBox />, label: "Iconic\nGold Box" },
];

const ServicePerks: React.FC = () => {
  return (
    <>
      <Box
        sx={{
          backgroundColor: "#F5F5F5",
          py: { xs: 4, md: 6 },
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={{ xs: 4, md: 6 }}
            justifyContent="space-around"
            alignItems="center"
          >
            {ITEMS.map((it, idx) => (
              <Grid
                item
                key={idx}
                xs={6}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                {/* icon (small & airy like the old design) */}
                <Box
                  sx={{
                    width: { xs: 44, md: 56 },
                    height: { xs: 44, md: 56 },
                    color: "black",
                    mb: 1.5,
                  }}
                >
                  {it.icon}
                </Box>

                {/* label (two-line, compact) */}
                <Typography
                  sx={{
                    whiteSpace: "pre-line",
                    color: "black",
                    fontFamily: `"Bodoni Moda", serif`,
                    fontSize: { xs: ".95rem", md: "1.0rem" },
                    lineHeight: 1.25,
                  }}
                >
                  {it.label}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
      <AboutUs />
      <HomeFaqSection />
    </>
  );
};

export default ServicePerks;
